import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface UIState {
  sidebarCollapsed: boolean;
  /** 2026-09-19: cajón de la barra lateral en celular/tablet (<lg). No se persiste. */
  mobileMenuOpen: boolean;
  theme: 'light' | 'dark';
  toggleSidebar: () => void;
  setSidebarCollapsed: (v: boolean) => void;
  setMobileMenu: (v: boolean) => void;
  setTheme: (t: 'light' | 'dark') => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set, get) => ({
      sidebarCollapsed: false,
      mobileMenuOpen: false,
      theme: 'light',
      toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),
      setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
      setMobileMenu: (v) => set({ mobileMenuOpen: v }),
      setTheme: (t) => set({ theme: t }),
    }),
    {
      name: 'clone-chat.ui',
      storage: createJSONStorage(() => localStorage),
      // el cajón del celular es efímero: si se guardara, el panel abriría con el menú puesto
      partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed, theme: s.theme }),
    },
  ),
);
